import axios from "axios";
import apiUrlOne from "../Config"; // Ensure this points to your correct base URL


export const createProduct = async (formData) => {
    const response = await axios.post(
        `${apiUrlOne}/products/create-products`,
        formData,
        {
            headers: {
                // "Content-Type": "multipart/form-data",
            },
        }
    );
    return response.data;
};


export const updateProduct = async (productId, formData) => {
    const response = await axios.put(
        `${apiUrlOne}/products/update-products/${productId}`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
    return response.data;
};


export const getAllProductsAdmin = async () => {
    const response = await axios.get(`${apiUrlOne}/products/getallproducts-admin`);
    console.log(response.data)
    return response.data;
};


export const deleteProduct = async (productId) => {
    const response = await axios.delete(`${apiUrlOne}/products/delete-products/${productId}`);
    return response.data;
};

export const getProductsByCategoryId = async (categoryId, query = {}) => {
    try {
        const response = await axios.get(`${apiUrlOne}/products/getproductby-categoryid-admin`, {
            params: { categoryId, ...query }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching products by category:", error);
        throw error;
    }
};
